import type { FaireProductEntity } from "../../entity_types/product";

export const p_96cac2juav: FaireProductEntity = {
  token: "p_96cac2juav",
  type: "product",
  name: "Grief Runs Deep Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e8f0bc0b18bd237f5368a962d5c2448ddbcc43a7f376d441393d511b1ec30806.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1babaea808b433bcdefb10031dadf00de5453c8ef3d63b47920393aacc41e396.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:04.897Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
